var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaintbrush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6E83B7",
    d: "M17,495c0,0,18.949,7.022,44,7c23.168-0.021,51.555-6.056,75-29.501C163.019,445.48,167,399,167,399 l-27-27l-27-27c0,0-46.48,3.981-73.499,31C16.056,399.445,10.021,427.832,10,451C9.978,476.051,17,495,17,495z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#EDEFF1",
    points: "149,311 113,345 167,399 201,363  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6E83B7",
    d: "M465.009,15.896L149,311l52,52L496.104,46.991c8.06-8.672,7.814-22.166-0.558-30.538l0,0 C487.175,8.082,473.68,7.835,465.009,15.896z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFE352",
    points: "221.282,341.282 238.666,322.666 189.334,273.334 170.718,290.718  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintbrush);
export default __webpack_public_path__ + "static/media/paintbrush.ca3b2762496fb9ff696201a07274d9b0.svg";
export { ForwardRef as ReactComponent };